import { Component, OnInit, Directive, Input } from "@angular/core";
import { Global } from "src/global";
import { AppService } from "src/app/app.service";
import { AppHeaderService } from "../../header/app-header/app-header.service";
import { Router } from "@angular/router";
import { ModalController } from "@ionic/angular";

@Component({
  selector: "app-tutorialVids",
  templateUrl: "./tutorialVids.component.html",
  styleUrls: ["./tutorialVids.component.scss"],
})
export class TutorialVidsComponent implements OnInit {
  @Input() videoData: any;

  constructor(
    public globals: Global,
    private appservice: AppService,
    private appHeaderService: AppHeaderService,
    private router: Router,
    public modalController: ModalController
  ) {}

  ngOnInit() {
    this.globals.ContentPageTitle = "Tutorial Videos";
    this.globals.NoSplitPane = false;
    this.globals.enable_menu("LeftMenu", true);
    this.globals.enable_menu("RightMenu", false);
  }

  dismissModal() {
    this.modalController.dismiss();
  }

  mouseenter(event: any, url: string) {
    event.target.src = url;
  }
  navigateToURL(url: string) {
    this.appHeaderService.setByUrl(url);
    this.router.navigate([url], {
      queryParams: {
        displayState: "normal",
        navigatedFromLink: "/resources",
      },
    });
  }
}
